/** Default page number used for games search */
export const SEARCH_GAMES_DEFAULT_PAGE_NUMBER = 0;

/** Default page size used for games search */
export const SEARCH_GAMES_DEFAULT_PAGE_SIZE = 50;

/** Min size for gaming search */
export const MIN_SEARCH_TERM_LENGTH = 2;
